import {
    IListarPerguntasERespostasForm,
    IResponderPesquisaSatisfacao,
} from "../../../Interfaces/Geral/Formularios/FormulariosInterface";
import Axios from "../../Config/API";
import Service from "../../Service";

export async function ResponderPesquisaSatisfacaoService(
    idContaChat: number,
    idOrganizacao: string,
    requestBody: IResponderPesquisaSatisfacao
) {
    return Service(
        Axios.post(
            `/home/responderformulario/responderpesquisadesatisfacaohelpdesk?idContaChat=${idContaChat}&idOrganizacao=${idOrganizacao}`,
            requestBody
        )
    );
}

export async function ListarFormularioEPerguntaRespostasPesquisaSatisfacaoService(
    idFormulario: number,
    idOrganizacao: string
) {
    return Service(
        Axios.get<IListarPerguntasERespostasForm>(
            `/home/responderformulario/listarformularioperguntarespostas?idFormulario=${idFormulario}&idOrganizacao=${idOrganizacao}`
        )
    );
}

export async function ListarFormularioEPerguntaRespostasPesquisaSatisfacaoSelectService(
    idFormulario: number,
    idOrganizacao: string
) {
    return Service(
        Axios.get<Array<IListarPerguntasERespostasForm>>(
            `/home/responderformulario/listarformularioperguntarespostas?idFormulario=${idFormulario}&idOrganizacao=${idOrganizacao}`
        )
    );
}
